import { Check, Plus, Tag } from "lucide-react";
import { useBrandAnswer } from "@fox1ck-org/auth/saas/react";
import { Button, EmptyState, PageHeader, cn } from "@fox1ck-org/ui";
import { WriteOnly } from "@/components/auth/write-only";
import { useT, type TKey } from "@/lib/i18n";

/**
 * Офферы before the first one (board OfferEmpty): what an offer is, and the
 * three steps to a working link — the partner (done when one exists), the
 * offer, the campaign. «Импорт из CSV» is not drawn: there is no import RPC.
 */
export function OfferEmpty({ hasPartner, onCreate }: { hasPartner: boolean; onCreate: () => void }) {
  const t = useT();
  const { motif } = useBrandAnswer();
  const steps: { done: boolean; title: TKey; sub: TKey }[] = [
    { done: hasPartner, title: hasPartner ? "u6.empty.step1.done" : "u6.empty.step1", sub: "u6.empty.step1.sub" },
    { done: false, title: "u6.empty.step2", sub: "u6.empty.step2.sub" },
    { done: false, title: "u6.empty.step3", sub: "u6.empty.step3.sub" },
  ];
  return (
    <>
      <div className="shrink-0 px-5 pb-3 pt-4">
        <PageHeader title={t("u6.offers.title")} />
      </div>
      <div className="mx-5 mb-5 grid min-h-0 flex-1 place-items-center rounded-xl border border-dashed border-border-strong bg-card">
        <EmptyState
          icon={<Tag className="size-5" strokeWidth={1.5} />}
          motif={motif}
          title={t("u6.empty.title")}
          description={
            <div className="flex flex-col gap-5 text-left">
              <p className="max-w-[60ch]">{t("u6.empty.body")}</p>
              <ol className="flex flex-col gap-3">
                {steps.map((s, i) => (
                  <li key={s.title} className="flex items-start gap-3">
                    <span
                      className={cn(
                        "grid size-6 shrink-0 place-items-center rounded-full text-xs tabular-nums",
                        s.done ? "bg-ok-soft text-ok" : i === (hasPartner ? 1 : 0) ? "bg-primary-soft text-primary" : "bg-surface-3 text-muted-foreground",
                      )}
                    >
                      {s.done ? <Check className="size-3.5" /> : i + 1}
                    </span>
                    <span className="flex flex-col">
                      <b className="font-medium text-foreground">{t(s.title)}</b>
                      <span className="text-xs">{t(s.sub)}</span>
                    </span>
                  </li>
                ))}
              </ol>
            </div>
          }
          action={
            <WriteOnly>
              <Button variant="primary" onClick={onCreate}>
                <Plus className="size-4" /> {t("u6.empty.add")}
              </Button>
            </WriteOnly>
          }
        />
      </div>
    </>
  );
}
